import React from 'react'
import { Formik, Form } from 'formik'
import {
  InputField,
  InputSelectOptions,
  LoaderButton
} from 'components/molecules'
import PropTypes from 'prop-types'
import {
  STATUS,
  INITIATED_BY,
  REFUND_METHOD,
  RESOLUTION_ACTION
} from 'domains/customer-refund/constants'

const PER_PAGE = {
  10  : '10',
  25  : '25',
  50  : '50',
  100 : '100'
}

const propTypes = {
  filterValues               : PropTypes.object.isRequired,
  onClickSubmitForm          : PropTypes.func.isRequired,
  onClickReset               : PropTypes.func.isRequired,
  showResolutionActionFilter : PropTypes.func.isRequired
}

const defaultProps = {
  showResolutionActionFilter: true
}

/**
 * Form to filters Customer::Order data
 * @param {Object} filterValues - current url filter values
 * @param {Function} onClickSubmitForm - function to submit form
 * @param {Function} onClickReset - function to reset form
 */

const CustomerRefundFilterForm = ({
  filterValues,
  onClickSubmitForm,
  onClickReset,
  showResolutionActionFilter
}) => (
  <Formik
    initialValues={{
      per_page          : filterValues.per_page || '',
      number            : filterValues.number || '',
      product_sku       : filterValues.product_sku || '',
      created_at_from   : filterValues.created_at_from || '',
      created_at_to     : filterValues.created_at_to || '',
      status            : filterValues.status || '',
      refund_method     : filterValues.refund_method || '',
      resolution_action : filterValues.resolution_action || '',
      initiated_by      : filterValues.initiated_by || ''
    }}
    enableReinitialize={ true }
    onSubmit={ onClickSubmitForm }
  >
    {
      (formikProps) => (
        <Form>
          <div className='d-flex flex-wrap mt-3'>

            <InputField
              formGroupClassName='mr-3'
              type='text'
              name='number'
              label='Number'
              placeholder='Search by refund number'
              bsSize={ 'sm' }
            />
            <InputField
              formGroupClassName='mr-3'
              type='text'
              name='product_sku'
              label='SKU'
              placeholder='Search by SKU'
              bsSize={ 'sm' }
            />

            <InputField
              formGroupClassName='mr-3'
              type='date'
              label='Request Date From'
              name='created_at_from'
            />

            <InputField
              type='date'
              label='Request Date To'
              name='created_at_to'
            />
          </div>

          <div className='d-flex flex-wrap'>
            <InputField
              type='select'
              name='status'
              label='Status'
              bsSize={ 'sm' }
              formGroupClassName='mr-3'
            >
              <InputSelectOptions
                options={ STATUS }
              />
            </InputField>

            <InputField
              type='select'
              name='refund_method'
              label='Refund Method'
              bsSize={ 'sm' }
              formGroupClassName='mr-3'
            >
              <InputSelectOptions
                options={ REFUND_METHOD }
              />
            </InputField>

            {
              showResolutionActionFilter && (
                <InputField
                  type='select'
                  name='resolution_action'
                  label='Resolution Action'
                  bsSize={ 'sm' }
                  formGroupClassName='mr-3'
                >
                  <InputSelectOptions
                    options={ RESOLUTION_ACTION }
                  />
                </InputField>
              )
            }


            <InputField
              type='select'
              name='initiated_by'
              label='Initiated By'
              bsSize={ 'sm' }
              formGroupClassName='mr-3'
            >
              <InputSelectOptions
                options={ INITIATED_BY }
              />
            </InputField>

            <InputField
              type='select'
              name='per_page'
              label='Per Page'
              bsSize={ 'sm' }
              formGroupClassName='ml-auto'
            >
              <InputSelectOptions
                options={ PER_PAGE }
              />
            </InputField>
          </div>

          <LoaderButton
            color='primary'
            className='mt-auto'
            type='submit'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Filter'
          />
          <LoaderButton
            color='danger'
            disabled={ formikProps.isSubmitting }
            isLoading={ formikProps.isSubmitting }
            text='Reset'
            onClick={ onClickReset }
          />
        </Form>
      )
    }
  </Formik>
)

CustomerRefundFilterForm.propTypes    = propTypes
CustomerRefundFilterForm.defaultProps = defaultProps

export default CustomerRefundFilterForm
